import React from "react";
import IwuaDashCard from "./IwuaDashCard";
import BreadCrumb from "../../../layout/BreadCrumb";
import LeafletMap from "./LeafletMap";

function IwuaOverview() {
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
     <BreadCrumb breadcrumbs={[]} />
      <div className="white_card mt-[1.25rem] flex-1  "> 
        <IwuaDashCard /> 
        <div className="mt-[1.75rem]">
          {" "}
          <LeafletMap />
        </div>
      </div>
    </div>
  );
}

export default IwuaOverview;
